module.exports = __webpack_public_path__ + "static/media/group-appt-white.118af1da.svg";